<script>
export default {
  name: 'DownloadToolDialog',
  methods: {
    goTo() {
      window.open('https://go.acronis.com/cloud-backup-download');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<template>
  <el-dialog
    :title="$t('wrh-dashboard.download-tool-dialog-box.message.title')"
    @close="close"
    :show-close="true"
    visible
  >

    <p class="el-text el-text--body-24 mx-24 my-16">
      <strong class="block-strong">
        {{ $t('wrh-dashboard.download-tool-dialog-box.message.first-header') }}
      </strong>
      {{ $t('wrh-dashboard.download-tool-dialog-box.message.first-paragraph') }}
    </p>
    <p class="el-text el-text--body-24 mx-24 my-16">

      <strong class="block-strong">
        {{ $t('wrh-dashboard.download-tool-dialog-box.message.second-header') }}
      </strong>

      <i18n
        path="wrh-dashboard.download-tool-dialog-box.message.second-paragraph"
      >
        <template slot="toolName">
          <el-icon
            class="icon-highlight"
            name="i-acronis-cloud--16"
          />
          <span class="highlight"> {{ $t('wrh-dashboard.download-tool-dialog-box.message.tool-name') }}</span>
        </template>
      </i18n>
    </p>


    <template slot="footer">
      <el-button
        native-type="button"
        type="secondary"
        @click="close"
      >
        {{ $t('wrh-dashboard.download-tool-dialog-box.gotIt') }}

      </el-button>
      <el-button
        native-type="button"
        @click="goTo"
      >
        {{ $t('wrh-dashboard.download-tool-dialog-box.message') }}

        <el-icon
          name="i-external-link--16"
        />

      </el-button>
    </template>
  </el-dialog>
</template>


<style lang="scss" scoped>
.block-strong {
  display: block;
}
.highlight{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: $av-fixed-link;
}
.icon-highlight{
  margin-right:0.2rem;
  margin-left:0.2rem;
  color: $av-fixed-link;
}
</style>

